import { render, staticRenderFns } from "./CaseProcessingChangeSummaryView.vue?vue&type=template&id=587d95b0&scoped=true&"
import script from "./CaseProcessingChangeSummaryView.vue?vue&type=script&lang=js&"
export * from "./CaseProcessingChangeSummaryView.vue?vue&type=script&lang=js&"
import style0 from "./CaseProcessingChangeSummaryView.vue?vue&type=style&index=0&id=587d95b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "587d95b0",
  null
  
)

export default component.exports